import React, { useState, useEffect, useCallback } from 'react'
import { HTTP } from './../providers'
import { Header, Icon, Loader } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { TemplateCard } from '../components'
import { getClient } from './../utils/functions'

const PopupCatalog = () => {
  const [data, setData] = useState(null)
  const client = getClient()

  const getPopups = useCallback(() => {
    const baseURL = client.demoAPI
    const urls = [
      `${baseURL}/listPopups`,
    ]
    Promise.all(urls.map(url =>
      fetch(url)
        .then(response => {
          console.log('Popup Catalog:  ', response)
          return response.json()
        })
        .catch((error) => {
          console.log('Error listPopups:  ', error)
        })
    ))
      .then(response => {
        console.log('Popup Catalog (then):  ', response)
        let data = null
        if (response && response[0] !== undefined) {
          data = response
            .map((d) => d)
            .reduce((a, b) => a.concat(b))
            .sort((a, b) => parseInt(a.id) < parseInt(b.id))
        }
        setData(data)
      })
  }, [])

  useEffect(() => {
    getPopups()
  }, []);

  const onHandleDelete = useCallback((event, id) => {
    event.preventDefault()
    HTTP.delete(`${client.demoAPI}/deletePage/${id}`, { id: id })
      .then(() => {
        getPopups() // refresh popup
      })
  }, [])

  return (
    <>
      <Header as='h2'>
        <Icon name='edit' />
        <Header.Content>
          My Popups
          <Header.Subheader>
            Configure a popup background and other options via <Link to={'/manage-settings'}>app settings</Link>.
          </Header.Subheader>
        </Header.Content>
      </Header>
      {
        data
          ? <TemplateCard product="popup" data={data} onHandleDelete={onHandleDelete} />
          : (<Loader active inline='centered'>Loading</Loader>)
      }
    </>
  )
}

export default PopupCatalog
